/**
 * L7d – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** 7 days indicator. */
export default function L7DIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${(height || 20) * Screen.widthRatio}`}
      width={`${(width || 34) * Screen.widthRatio}`}
      viewBox={'0 0 34 20'}
    >
      <path
        d='M25.7685 16.3415V3.42683H27.2354C27.8064 3.42683 28.2904 3.55169 28.7024 3.78756L28.7024 3.78757L28.7046 3.78884C29.1264 4.0275 29.4938 4.38386 29.8027 4.87572L29.8027 4.87572L29.8045 4.87854C30.1138 5.36358 30.3586 5.97729 30.5287 6.73191L30.529 6.73299C30.6985 7.47729 30.7859 8.34131 30.7859 9.32927V10.4146C30.7859 11.668 30.6319 12.7433 30.3348 13.649L30.3343 13.6505C30.0451 14.5418 29.6224 15.2042 29.0839 15.6688C28.5646 16.1088 27.9066 16.3415 27.0737 16.3415H25.7685ZM23.7896 0.5H23.5352H23.0352V1V18.7561V19.2561H23.5352H23.8388H24.3435H25.2685H25.7685H27.0737C28.0559 19.2561 28.9548 19.0493 29.7589 18.6252L29.7612 18.6239C30.5643 18.1949 31.244 17.5846 31.8002 16.8033C32.362 16.0226 32.783 15.0915 33.0711 14.0201L33.0713 14.0191C33.3599 12.9371 33.5013 11.7342 33.5013 10.4146V9.35366C33.5013 8.03438 33.36 6.83536 33.0712 5.76099C32.7837 4.6833 32.3666 3.74894 31.8116 2.9684C31.2637 2.18131 30.6003 1.56945 29.8193 1.14662C29.0348 0.713718 28.1701 0.5 27.2354 0.5H25.7685H25.2685H24.2896H23.7896Z'
        fill={focused ? Colors['dark'] : Colors['light']}
        stroke={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M21.5 1V0.5H21H13H12.5V1V2.87912V3.37912H13H18.7322L14.0338 18.8547L13.8379 19.5H14.5122H16.0976H16.472L16.5773 19.1407L21.4798 2.42644L21.5 2.35753V2.28571V1Z'
        fill={focused ? Colors['dark'] : Colors['light']}
        stroke={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M8.74179 0.5H8.24179V1V13.0122C8.24179 13.8986 8.12085 14.5915 7.90326 15.112C7.6827 15.6397 7.38795 15.9984 7.03432 16.2258L7.03432 16.2258L7.03178 16.2275C6.67405 16.4606 6.24472 16.5854 5.72411 16.5854C5.21125 16.5854 4.78076 16.4614 4.41512 16.2266C4.06736 15.9995 3.77494 15.6408 3.55394 15.1121C3.33635 14.5915 3.21541 13.8986 3.21541 13.0122V1V0.5H2.71541H1H0.5V1V13.0122C0.5 14.3935 0.713473 15.5809 1.16653 16.5527L1.16652 16.5527L1.16771 16.5552C1.62074 17.5131 2.24542 18.2592 3.05136 18.765L3.05135 18.765L3.05645 18.7681C3.85763 19.2577 4.75101 19.5 5.72411 19.5C6.66008 19.5 7.53169 19.2552 8.3289 18.7681L8.33081 18.7669C9.14732 18.263 9.78716 17.5192 10.259 16.5626C10.7397 15.588 10.9662 14.3967 10.9662 13.0122V1V0.5H10.4662H8.74179Z'
        fill={focused ? Colors['dark'] : Colors['light']}
        stroke={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
